import React from 'react';
import { Author } from 'components/author/Author';
import { Quote } from 'components/quote/Quote';
import { RichText } from 'components/rich-text/RichText';

export const QuoteSlice = ({
  quote,
  attribution,
  position,
  image,
  allowBackground,
  isSlice,
  isSplitPage,
  isArticle,
}) => {
  return (
    <Quote
      text={RichText.render(quote)}
      background={allowBackground}
      attribution={<Author name={attribution} position={position} image={image} />}
      isSlice={isSlice}
      isSplitPage={isSplitPage}
      isArticle={isArticle}
    />
  );
};

export default QuoteSlice;
